var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinnerTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.25C2.41421 3.25 2.75 3.58579 2.75 4V14.25H8C8.9665 14.25 9.75 15.0335 9.75 16V20C9.75 20.4142 9.41421 20.75 9 20.75C8.58579 20.75 8.25 20.4142 8.25 20V18C8.25 17.8619 8.13807 17.75 8 17.75H2.75V20C2.75 20.4142 2.41421 20.75 2 20.75C1.58579 20.75 1.25 20.4142 1.25 20V4C1.25 3.58579 1.58579 3.25 2 3.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 4C21.25 3.58579 21.5858 3.25 22 3.25C22.4142 3.25 22.75 3.58579 22.75 4V20C22.75 20.4142 22.4142 20.75 22 20.75C21.5858 20.75 21.25 20.4142 21.25 20V17.75H16C15.8619 17.75 15.75 17.8619 15.75 18V20C15.75 20.4142 15.4142 20.75 15 20.75C14.5858 20.75 14.25 20.4142 14.25 20V16C14.25 15.0335 15.0335 14.25 16 14.25H21.25V4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.75C17.4142 10.75 17.75 10.4142 17.75 10V9C17.75 8.44772 17.3023 8 16.75 8H7.25C6.69772 8 6.25 8.44772 6.25 9V10C6.25 10.4142 6.58579 10.75 7 10.75H11.25V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V10.75H17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinnerTable);
export default __webpack_public_path__ + "static/media/dinner-table.4eb7b5d0d7518d49cf8cce270a6fb1c0.svg";
export { ForwardRef as ReactComponent };